import React, { FC } from "react";
import CohortAnalysis from "../components/CohortAnalysis";

const Cohort: FC = () => {
  return <CohortAnalysis />;
};

export default Cohort;
